import { useState } from "react"

import { SetCurrentScreen } from "../../../../components/account/providers/firstLoginProvider"
import {
    INVITE_ACCEPTED_SUCCESS,
    MFA,
} from "../../../../components/account/screenDispatchers/firstLoginConstants"
import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { IAppError } from "../../../../errors/errorTypes"
import { useGetUserData } from "../../../../hooks/useGetUserData"
import { patchClientProtected } from "../../clients/clients"
import { ACCPETING_INVITE } from "../../urls/private"

interface IUseAcceptInvites {
    isAccepting: boolean
    error: IAppError | undefined
    acceptInvite: () => Promise<void>
}

/**
 * Used to Accept an invite to join an organisation
 * @returns {IUseAcceptInvites} - loading and error states.
 */
const useAcceptInvite = (
    setCurrentScreen: SetCurrentScreen
): IUseAcceptInvites => {
    const { hasSetMfa } = useGetUserData()
    const [isAccepting, setIsAccepting] = useState(false)
    const [error, setError] = useState<IAppError | undefined>(undefined)

    const acceptInvite = async (): Promise<void> => {
        try {
            setIsAccepting(true)
            await patchClientProtected(ACCPETING_INVITE, null)
            if (hasSetMfa) {
                setCurrentScreen(INVITE_ACCEPTED_SUCCESS)
            } else {
                setCurrentScreen(MFA)
            }
            setError(undefined)
        } catch (err) {
            const errorObj = parseErrorAsObj(err)
            setError(errorObj)
        } finally {
            setIsAccepting(false)
        }
    }

    return {
        isAccepting,
        error,
        acceptInvite,
    }
}

export default useAcceptInvite
